module.exports = __webpack_public_path__ + "static/5mb-3f00271c5ee6e3163dfa81f611ac49ce.mp4";